import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/products";

/**
 * Rotating sparkle separator — spins continuously in place.
 */
const SpinSparkle = () => (
  <span
    className="inline-flex items-center justify-center mx-6 align-middle"
    style={{
      width: 18,
      height: 18,
      animation: "ggSpin 3.6s linear infinite",
      display: "inline-block",
    }}
    aria-hidden="true"
  >
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
      <path
        d="M12 1.5 L13.4 9.4 L21.5 11.2 L13.4 13 L12 22.5 L10.6 13 L2.5 11.2 L10.6 9.4 Z"
        fill="#D4537E"
      />
      <circle cx="12" cy="11.2" r="1.3" fill="#FDF6F0" />
    </svg>
  </span>
);

const AnnouncementMarquee = () => {
  return (
    <section
      className="py-5 overflow-hidden marquee-mask"
      style={{ background: "#FDF6F0" }}
      data-testid="announcement-marquee"
    >
      <style>{`
        @keyframes ggSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <Marquee gradient={false} speed={40} pauseOnHover>
        {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
          <div key={i} className="flex items-center">
            <SpinSparkle />
            <span className="font-serif italic text-plum text-lg lg:text-xl">
              {item}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default AnnouncementMarquee;
